import { FirebaseError } from 'firebase/app';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useState, type FormEvent } from 'react';
import { Link, useLocation } from 'react-router';
import { Field } from '../components/Field';
import { auth } from '../firebase';
import { errorMessage } from '../lib/errors';

export function ForgotPasswordPage() {
  const location = useLocation();
  const [email, setEmail] = useState((location.state as { email?: string } | null)?.email ?? '');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setSent(true);
    } catch (err) {
      // Never reveal whether an account exists, even if enumeration protection is off.
      if (err instanceof FirebaseError && err.code === 'auth/user-not-found') setSent(true);
      else setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-card">
      <h1>Reset password</h1>
      {sent ? (
        // Same message whether or not the account exists (email enumeration protection).
        <p className="alert alert--info" role="status">
          If a staff account exists for {email.trim()}, a reset link is on its way. Check your inbox.
        </p>
      ) : (
        <form onSubmit={submit} noValidate>
          <p className="muted">We'll email you a link to set a new password.</p>
          <Field
            label="Email"
            name="email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && (
            <p className="alert alert--error" role="alert">
              {error}
            </p>
          )}
          <button className="btn btn--primary btn--block" type="submit" disabled={busy || !email.trim()}>
            {busy ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
      <p className="auth-card__links">
        <Link to="/login">Back to sign in</Link>
      </p>
    </div>
  );
}
